// 아이디 찾기 페이지 JavaScript

// 설정: 표시 방식 선택
// 'alert' - 알림만 사용
// 'both' - 알림 + 결과 영역 모두 표시
const DISPLAY_MODE = 'both'; // 'alert' 또는 'both'

// 탭 전환 기능
function switchTab(tabType) {
  // 모든 탭 버튼 비활성화
  document.querySelectorAll('.tab-btn').forEach(btn => {
    btn.classList.remove('active');
  });
  
  // 모든 탭 콘텐츠 숨김
  document.querySelectorAll('.tab-content').forEach(content => {
    content.classList.remove('active');
    content.style.display = 'none';
  });
  
  // 선택된 탭 활성화
  event.target.classList.add('active');
  const selectedTab = document.getElementById(tabType + 'Tab');
  selectedTab.classList.add('active');
  selectedTab.style.display = 'block';
}

// 더미 회원 데이터 (실제 서비스에서는 서버에서 조회)
const memberData = [
  {
    name: 'custom1',
    phone: '010-1234-5678',
    email: 'hong@example.com',
    userId: 'custom1',
    joinDate: '2023-03-15'
  },
  {
    name: '김철수',
    phone: '010-9876-5432',
    email: 'kim@example.com',
    userId: 'kimcs2024',
    joinDate: '2024-01-20'
  },
  {
    name: '이영희',
    phone: '010-5555-7777',
    email: 'lee@example.com',
    userId: 'leeyh789',
    joinDate: '2023-11-08'
  }
];

// 폼 제출 처리
document.addEventListener('DOMContentLoaded', function() {
  const form = document.getElementById('findIdForm');
  
  if (!form) {
    // 아이디 찾기 페이지가 아님 - 조용히 종료
    return;
  }
  
  form.addEventListener('submit', function(e) {
    e.preventDefault();
    
    const activeTab = document.querySelector('.tab-content.active');
    const isPhoneTab = activeTab.id === 'phoneTab';
    
    let name, identifier;
    
    if (isPhoneTab) {
      name = document.getElementById('name').value.trim();
      identifier = document.getElementById('phone').value.trim();
    } else {
      name = document.getElementById('name2').value.trim();
      identifier = document.getElementById('email').value.trim();
    }
    
    // 입력 검증
    if (!name || !identifier) {
      alert('모든 항목을 입력해주세요.');
      return;
    }
    
    // 아이디 찾기 시뮬레이션
    searchUserId(name, identifier, isPhoneTab);
  });
});

// 아이디 검색 함수
function searchUserId(name, identifier, isPhone) {
  // 로딩 시뮬레이션
  const submitBtn = document.querySelector('.btn-primary');
  const originalText = submitBtn.textContent;
  submitBtn.textContent = '검색 중...';
  submitBtn.disabled = true;
  
  setTimeout(() => {
    // 더미 데이터에서 검색
    const foundMembers = memberData.filter(member => {
      const nameMatch = member.name === name;
      const identifierMatch = isPhone ? 
        member.phone === identifier : 
        member.email === identifier;
      
      return nameMatch && identifierMatch;
    });
    
    submitBtn.textContent = originalText;
    submitBtn.disabled = false;
    
    if (foundMembers.length > 0) {
      // 찾은 아이디를 알림으로 표시
      let message = '아이디를 찾았습니다\n\n';
      foundMembers.forEach((member, index) => {
        message += `아이디: ${member.userId}\n`;
        message += `가입일: ${member.joinDate}\n`;
        if (index < foundMembers.length - 1) {
          message += '\n';
        }
      });
      
      // 설정에 따라 표시 방식 결정
      if (DISPLAY_MODE === 'alert') {
        // 알림만 표시
        alert(message);
      } else if (DISPLAY_MODE === 'both') {
        // 알림 먼저 표시
        alert(message);
        // 그 다음 결과 영역도 표시
        showSearchResults(foundMembers);
      }
    } else {
      showNoResults();
    }
  }, 1500);
}

// 검색 결과 표시 (결과 영역에)
function showSearchResults(members) {
  const form = document.getElementById('findIdForm');
  const resultArea = document.getElementById('resultArea');
  const foundIdsContainer = resultArea.querySelector('.found-ids');
  
  // 결과 HTML 생성
  let resultsHTML = '';
  members.forEach(member => {
    resultsHTML += `
      <div class="found-id-item">
        <div class="id-display">
          <strong>아이디:</strong> ${member.userId}
        </div>
        <div class="date-display">
          <strong>가입일:</strong> ${member.joinDate}
        </div>
      </div>
    `;
  });
  
  foundIdsContainer.innerHTML = resultsHTML;
  
  // 폼 숨기고 결과 표시
  form.style.display = 'none';
  resultArea.style.display = 'block';
}

// 검색 결과 없음 표시
function showNoResults() {
  alert('입력하신 정보와 일치하는 아이디를 찾을 수 없습니다.\n\n다시 확인해주시거나 고객센터로 문의해주세요.\n전화: 1833-8996');
}

// 전화번호 자동 포맷팅
document.addEventListener('DOMContentLoaded', function() {
  const phoneInputs = document.querySelectorAll('input[type="tel"]');
  
  phoneInputs.forEach(input => {
    input.addEventListener('input', function(e) {
      let value = e.target.value.replace(/[^0-9]/g, '');
      
      if (value.length >= 3 && value.length <= 7) {
        value = value.replace(/(\d{3})(\d+)/, '$1-$2');
      } else if (value.length >= 8) {
        value = value.replace(/(\d{3})(\d{4})(\d+)/, '$1-$2-$3');
      }
      
      e.target.value = value;
    });
  });
});
